import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {EntityKeyService} from '@pma-entity/services/entity-key.service';
import {EntityDataLayoutService} from "@layout/layouts/entity-data/entity-data-layout.service";
import {ListPageComponentBase} from "@mojo-mci/list-page-component-base";

@Component({
    selector: 'mojo-debtor-list-page',
    templateUrl: './debtor-list-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DebtorListPageComponent
  extends ListPageComponentBase
  implements OnInit, OnDestroy {

  constructor(
    private readonly router: Router,
    entityKeyService: EntityKeyService,
    entityDataLayoutService: EntityDataLayoutService) {
    super(entityKeyService, entityDataLayoutService);
  }

  ngOnInit(): void {
    super.ngOnInit('Debtors');
  }

  handleRowSelect(data) {
    this.router.navigate(['/entity-data/debtor', data['SystemDebtorUri']]);
  }

  getRowHref = (row) => {
    const debtorRef = row['SystemDebtorUri'];
    return `/entity-data/debtor/${debtorRef}`;
  }
}
